import { Box, Button, Divider, Tooltip, Typography } from "@mui/material";
import { useContext, useState } from "react";
import { Link } from "react-router-dom";
import { AppFeatureLookup } from "../../../../App/Constants/AbacConstants";
import { crmLiteUpgradeMessage } from "../../../../App/Constants/CrmLiteConstants";
import { useCandidateToGroupsMutation } from "../../../../App/Queries/CandidateQueries";
import { useFeaturePermission } from "../../../../App/State/Hooks/abacHooks";
import { ICandidateProfileGroup } from "../../../../App/Typings/CandidateProfile";
import { CandidateContext } from "../../../CandidateProfile";
import { AddToGroupOptions } from "./AddToGroup/AddToGroupOptions";

export default function ProfileGroupInfo() {
  const {
    candidate: { groups },
  } = useContext(CandidateContext);
  const [showAddToGroups, setShowAddToGroups] = useState(false);
  const addToGroupButtonAccess = useFeaturePermission(AppFeatureLookup.CandidatesAddCandidatesToGroup);
  const { isLoading } = useCandidateToGroupsMutation();

  const handleToggleAddToGroup = () => {
    if (!addToGroupButtonAccess) {
      return;
    }
    setShowAddToGroups(!showAddToGroups);
  };

  return (
    <Box>
      <Tooltip title={addToGroupButtonAccess ? "Add to Group" : crmLiteUpgradeMessage}>
        <span>
          <Button
            variant="outlined"
            color="secondary"
            onClick={handleToggleAddToGroup}
            data-test="add-to-groups-button"
            disabled={!addToGroupButtonAccess || isLoading}
          >
            Add to Group
          </Button>
        </span>
      </Tooltip>
      <Divider sx={{ my: 2 }} />
      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
      >
        {groups && groups.length > 0
          ? groups.map((group, idx) => <ProfileGroupListing key={idx} group={group} />)
          : "Not assigned to any groups"}
      </Box>
      <AddToGroupOptions showAddToGroups={showAddToGroups} setShowAddToGroups={setShowAddToGroups} />
    </Box>
  );
}

function ProfileGroupListing({ group }: { group: ICandidateProfileGroup }) {
  return (
    <Box
      sx={{
        "& a": {
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          textDecoration: "none",
          color: "text.primary",
        },
      }}
    >
      <Link to={`/candidategroups/${group.id}`}>
        <Typography data-test={`candidate-group-${group.id}`} sx={{ fontWeight: "600" }}>
          {group.name}
        </Typography>
        <Typography>{group.memberCount} Candidates</Typography>
      </Link>
    </Box>
  );
}
